import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";

export const doRegister = ( newpass, token, onComplete ) =>
{
    const url = Globals.APIFolder + '/register'

    const data = {
        password: newpass,
        token: token
    } ;

    getDataWithPromise ( url, 'POST', data )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const doPasswordReset = ( username, onComplete ) =>
{
    const url = Globals.APIFolder + '/resetpassword'

    const data = {
        inpUsername: username,
    } ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const setPrivacyRead = ( onComplete ) =>
{
    const url = Globals.APIFolder + '/users/self/privacy_ack' ;

    getDataWithPromise ( url, 'PUT', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
